import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW"; 

export default function FechGetClass(club, classId) {
 
  var url = "/class_app/" + club + "/class/show/" + classId;

  return FetchGetDataWithAuthNEW(url);
}

